import React, { createContext, useContext, useState, useCallback } from 'react';

// Base storage currency is SAR. USD is derived at a fixed peg.
export const SAR_PER_USD = 3.75;
const STORAGE_KEY = 'byanfal_currency';

const CurrencyContext = createContext(null);

export function CurrencyProvider({ children }) {
    const [currency, setCurrencyState] = useState(() => {
        const saved = typeof window !== 'undefined' ? window.localStorage.getItem(STORAGE_KEY) : null;
        return saved === 'USD' ? 'USD' : 'SAR';
    });

    const setCurrency = useCallback((c) => {
        const next = c === 'USD' ? 'USD' : 'SAR';
        setCurrencyState(next);
        try { window.localStorage.setItem(STORAGE_KEY, next); } catch { /* ignore */ }
    }, []);

    const toggle = useCallback(() => setCurrency(currency === 'SAR' ? 'USD' : 'SAR'), [currency, setCurrency]);

    // amount is always stored in SAR (base). Returns a formatted display string.
    const format = useCallback((amountSar) => {
        const n = Number(amountSar) || 0;
        if (currency === 'USD') {
            const usd = n / SAR_PER_USD;
            return `$${usd.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
        }
        return `SAR ${n.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
    }, [currency]);

    return (
        <CurrencyContext.Provider value={{ currency, setCurrency, toggle, format }}>
            {children}
        </CurrencyContext.Provider>
    );
}

export function useCurrency() {
    const ctx = useContext(CurrencyContext);
    if (!ctx) throw new Error('useCurrency must be used within CurrencyProvider');
    return ctx;
}
